import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export function submitAttributionFormConfiguration({
  rootId,
  formName,
  formValues,
}) {
  return new NetworkRequestConfiguration({
    endpoint: `attributions/${formName}`,
    method: NetworkRequestConfiguration.Methods.POST,
    successCodes: [201],
    bodyParameters: {
      rootId,
      formValues,
    },
  });
}

export const FORM_NAME_OPTIONS = {
  AGENCY_ONBOARDING: 'agency_onboarding',
};
